module.exports = __webpack_public_path__ + "img/txt_info3.935add3b.png";